import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import appManager from "./slices/appManagerSlice";
import employee from "./slices/setup/organization/employeeSlice";
import branch from "./slices/setup/organization/branchSlice";
import productTC from "./slices/setup/organization/productTcSlice";
import prospect from "./slices/prospect/prospectSlice";
import products from "./slices/setup/organization/productsSlice";
import productCollection from "./slices/setup/organization/productCollectionSlice";
import subProduct from "./slices/setup/organization/SubProductSlice";
import subProductOffering from "./slices/setup/organization/subProductOfferingSlice";
import subProductOfferingDetail from "./slices/setup/organization/subProductOfferingSliceDetailSlice";
import subProductFinanceAsset from "./slices/setup/organization/SubProductFinanceAssetSlice";
import assetType from "./slices/setup/organization/AssetTypeSlice";
import assetCategory from "./slices/setup/organization/AssetCategorySlice";
import assetBrand from "./slices/setup/organization/AssetBrandSlice";
import assetBrandType from "./slices/setup/organization/AssetBrandTypeSlice";
import assetAttribute from "./slices/setup/organization/AssetAttributeSlice";
import jenisPengikatan from "./slices/setup/organization/JenisPengikatanSlice";
import collateralAsset from "./slices/setup/organization/CollateralAssetSlice";
import collateralType from "./slices/setup/organization/CollateralTypeSlice";
import collateralDocument from "./slices/setup/organization/CollateralDocumentSlice";
import productDocument from "./slices/setup/organization/productDocumentSlice";
import companyCustomer from "./slices/setup/organization/CompanyCustomerSlice";
import personalCustomer from "./slices/setup/organization/PersonalCustomerSlice";
import customerGroup from "./slices/setup/organization/CustomerGroupSlice";
import groupMenu from "./slices/groupMenuSlice";
import protectedRoutes from "./slices/protectedRoutesSlice";
import customer from "./slices/setup/organization/CustomerSlice";
//import supplier from "./slices/setup/organization/SupplierSlices/SupplierSlice";
//import supplierGroupSlice from "./slices/setup/organization/SupplierSlices/SupplierGroupSlice";
import applikasiKredit from "./slices/setup/loanOrigination/loan/ApplikasiKreditSlice";
import prospectOrganiz from "./slices/setup/organization/ProspectSlices/ProspectSlice";
import prospectScreening from "./slices/setup/organization/ProspectScreeningSlices/ProspectScreeningSlice";
//import agency from "./slices/setup/organization/AgencySlices/AgencySlice";
import agencyEmployee from "./slices/setup/organization/AgencyEmployeeSlices/AgencyEmployeeSlice";

//Master
import supplierGroup from "./slices/setup/supplier/supplierGroupSlice";
import supplierSlice from "./slices/setup/supplier/supplierSlice";
import supplierOwnerSlice from "./slices/setup/supplier/supplierOwnerSlice";
import productTypeOfUse from "./slices/master/productTypeOfUseSlice";
import masterTc from "./slices/master/masterTcSlice";
import masterDocument from "./slices/master/masterDocumentSlice";
import workflowProcess from "./slices/master/workflowProcessSlice";
import subproductFeeCharges from "./slices/setup/organization/subproductFeeChargesSlice";
import masterProduct from "./slices/master/masterProductSlice";
import masterAsset from "./slices/master/masterAssetSlice";
import masterCustomer from "./slices/master/masterCustomerSlice";
import masterZipCode from "./slices/master/masterZipCodeSlice";
import assetMaster from "./slices/master/assetMastersSlice";
import reference from "./slices/master/referenceSlice";

// Insurance
import insuranceComHO from "./slices/setup/InsuranceSettingManagement/InsuranceComHOSlice";
import apkLoanKKBFinancial1 from "./slices/setup/loanOrigination/Financial/ApkLoanKKBFinancial1Slice";
import apkLoanKKBFinancial2 from "./slices/setup/loanOrigination/Financial/ApkLoanKKBFinancial2Slice";
import apkLoanKTAFinancial1 from "./slices/setup/loanOrigination/Financial/ApkLoanKTAFinancial1Slice";
import apkLoanKTAFinancial2 from "./slices/setup/loanOrigination/Financial/ApkLoanKTAFinancial2Slice";
import Incentive from "./slices/setup/loanOrigination/Incentive/incentiveSlice";
import apkLoanInsuranceKKB from "./slices/setup/loanOrigination/ApkLoanInsuranceKKB/ApkLoanInsuranceKKBSlice";

// Prospect
import inputprospect from "./slices/prospect/inputprospectSlice";
import incentiveKKB from "./slices/prospect/incentiveSlice";

// creditScoringItem
import creditScoringItem from "./slices/setup/creditScoringItem/creditScoringItemSlice";

// creditScoringItem
import creditAssessment from "./slices/setup/loanOrigination/CreditAssessment/CreditAssessmentSlice";

// creditScoringItem
import approvalKredit from "./slices/setup/loanOrigination/ApprovalKredit/ApprovalKreditSlice";

import CollateralManagement from "./slices/setup/loanOrigination/CollateralManagement/CollateralManagementSlice";
import CollateralCustomer from "./slices/setup/loanOrigination/CollateralManagement/CollateralManagementCustomerSlice";

// Approval
import approvalComponentMaster from "./slices/setup/approvalComponentMaster/approvalComponentMasterSlice";
import approvalTypeScheme from "./slices/setup/approvalTypeScheme/approvalTypeSchemeSlice";
import approvalSchemeComponent from "./slices/setup/ApprovalSchemeComponent/approvalSchemeComponentSlice";

// RCAPengajuanApproval
import RCAPengajuanApproval from "./slices/setup/RCAPengajuanApproval/RCAPengajuanApprovalSlice";

import deliveryOrder from "./slices/setup/loanOrigination/DeliveryOrder/DeliveryOrderSlice";

// Activation

import loanActivation from "./slices/setup/loanOrigination/LoanActivation/loanActivationSlices";

// APKFAS1
import apkFas1 from "./slices/setup/loanOrigination/APKFAS1/APKFAS1Slices";

import facilityBankAnalysis from "./slices/setup/loanOrigination/FacilityBankAnalysis/FacilityBankAnalysisSlice";

import facilityActivation from "./slices/setup/FacilityActivation/FacilityActivationSlice";
import apkLoanAsset from "./slices/setup/loanOrigination/ApkLoanAsset/ApkLoanAssetSlice";
import apkLoanFee from "./slices/setup/loanOrigination/ApkLoanFee/ApkLoanFeeSlice";
import purchaseOrder from "./slices/setup/loanOrigination/PurchaseOrder/PurchaseOrderSlice";

//Shared Component
import themeConstant from "./slices/themeConstantSlice";
import productCode from "./slices/master/productCodeSlice";
import productCodeApprv from "./slices/master/productCodeApprvSlice";
import subProductCode from "./slices/master/subProductCodeSlice";
import subProductCodeApprv from "./slices/master/subProductCodeApprvSlice";
import assetTypeCode from "./slices/master/assetTypeCodeSlice";
import assetTypeCodeApprv from "./slices/master/assetTypeCodeApprvSlice";
import assetCategoryCode from "./slices/master/assetCategoryCodeSlice";
import assetCategoryCodeApprv from "./slices/master/assetCategoryCodeApprvSlice";
import assetBrandCode from "./slices/master/assetBrandCodeSlice";
import assetBrandCodeApprv from "./slices/master/assetBrandCodeApprvSlice";
import assetBrandTypeCode from "./slices/master/assetBrandTypeCodeSlice";
import assetBrandTypeCodeApprv from "./slices/master/assetBrandTypeCodeApprvSlice";
import assetAttributeCode from "./slices/master/assetAttributeCodeSlice";
import assetAttributeCodeApprv from "./slices/master/assetAttributeCodeApprvSlice";
import jenisPengikatanCode from "./slices/master/jenisPengikatanCodeSlice";
import jenisPengikatanCodeApprv from "./slices/master/jenisPengikatanCodeApprvSlice";
import collateralAssetCode from "./slices/master/collateralAssetCodeSlice";
import collateralAssetCodeApprv from "./slices/master/collateralAssetCodeApprvSlice";
import collateralTypeCode from "./slices/master/collateralTypeCodeSlice";
import collateralTypeCodeApprv from "./slices/master/collateralTypeCodeApprvSlice";
import collateralDocumentCode from "./slices/master/collateralDocumentCodeSlice";
import collateralDocumentCodeApprv from "./slices/master/collateralDocumentCodeApprvSlice";
import financeAssetCode from "./slices/master/financeAssetCodeSlice";
import financeAssetCodeApprv from "./slices/master/financeAssetCodeApprvSlice";
import companyCustomerCode from "./slices/master/companyCustomerCodeSlice";
import customerCode from "./slices/master/customerCodeSlice";
import customerGroupCode from "./slices/master/customerGroupCodeSlice";
import supplierCode from "./slices/master/SupplierSlices/supplierCodeSlice";
import supplierCodeApprv from "./slices/master/SupplierSlices/supplierCodeApprvSlice";
import referenceOJKSlice from "./slices/master/referenceOJKSlice";
import prospectCode from "./slices/master/ProspectSlices/prospectCodeSlice";

import SPPA from "./slices/insurance/SPPASlice";
//import SimulasiAngsuran from "./slices/setup/Financial/SimulasiAngsuranSlice";
import SimulasiAngsuran from "./slices/setup/financial/SimulasiAngsuranSlice";
import LMSLoanPayment from "./slices/lms/LMSLoanPaymentSlice";
import LMSRestrukturisasi from "./slices/lms/LMSRestrukturisasiSlice";
import BankAccount from "./slices/lms/BankAccountSlice";
import GlAccount from "./slices/lms/glAccount/GlAccountSelice";
import Pdc from "./slices/lms/PDCSlice";
import PaymentApproval from "./slices/lms/PaymentApprovalSlice";

//collateral
import collateral from "./slices/collateral/collateralSlice";

import receptionSuspend from "./slices/lms/suspend/receptionSuspendSlice";
import reversalSuspend from "./slices/lms/suspend/reversalSuspendSlice";
import suspendSplit from "./slices/lms/suspend/suspendSplitSlice";
import bankAccount from "./slices/setup/BankAccount/BankAccountSlice";
import glAccount from "./slices/setup/GLAccount/GLAccountSlice";
import jurnalTemplate from "./slices/setup/Jurnal/JurnalTemplateSlice";
import glJournalQueryBuilder from "./slices/setup/Jurnal/GlJournalQueryBuilderSlice";
import glJournalScheme from "./slices/setup/Jurnal/GlJournalSchemeSlice";
import glMasterSequence from "./slices/setup/Jurnal/GLMasterSequenceSlice";
import loanVA from "./slices/loanmgt/loan/loanVA/loanVASlice";
import virtualAccount from "./slices/loanmgt/virtualaccount/virtualaccountslice";

import supplierInvoice from "./slices/setup/supplier/supplierInvoiceSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    groupMenu,
    protectedRoutes,
    themeConstant,
    theme,
    auth,
    employee,
    branch,
    prospect,
    Prospect: prospectCode,
    prospectOrganiz,
    products,
    subProduct,
    productCollection,
    subProductFinanceAsset,
    assetType,
    assetCategory,
    assetBrand,
    assetBrandType,
    assetAttribute,
    jenisPengikatan,
    collateralAsset,
    collateralType,
    collateralDocument,
    customer,
    applikasiKredit,
    companyCustomer,
    personalCustomer,
    //supplierGroup,
    supplierSlice,
    supplierOwnerSlice,
    productTypeOfUse,
    masterTc,
    productTC,
    productDocument,
    masterDocument,
    workflowProcess,
    subProductOffering,
    subProductOfferingDetail,
    appManager,
    masterProduct,
    masterAsset,
    masterCustomer,
    masterZipCode,
    productCode,
    productCodeApprv,
    subproductFeeCharges,
    subProductCode,
    subProductCodeApprv,
    //supplier,
    //supplierGroupSlice,
    //Prospect,
    prospectScreening,
    //agency,
    agencyEmployee,
    apkLoanAsset,
    apkLoanFee,
    purchaseOrder,

    assetTypeCode,
    assetTypeCodeApprv,
    assetCategoryCode,
    assetCategoryCodeApprv,
    assetBrandCode,
    assetBrandCodeApprv,
    assetBrandTypeCode,
    assetBrandTypeCodeApprv,
    assetAttributeCode,
    assetAttributeCodeApprv,
    assetMaster,
    reference,

    insuranceComHO,
    apkLoanKKBFinancial1,
    apkLoanKKBFinancial2,
    apkLoanKTAFinancial1,
    apkLoanKTAFinancial2,
    Incentive,
    apkLoanInsuranceKKB,

    inputprospect,
    incentiveKKB,
    creditScoringItem,
    creditAssessment,
    approvalKredit,
    CollateralManagement,
    CollateralCustomer,
    approvalComponentMaster,
    approvalTypeScheme,
    approvalSchemeComponent,
    RCAPengajuanApproval,
    deliveryOrder,
    loanActivation,
    apkFas1,
    facilityBankAnalysis,
    facilityActivation,
    jenisPengikatanCode,
    jenisPengikatanCodeApprv,
    collateralAssetCode,
    collateralAssetCodeApprv,
    collateralTypeCode,
    collateralTypeCodeApprv,
    collateralDocumentCode,
    collateralDocumentCodeApprv,
    financeAssetCode,
    financeAssetCodeApprv,
    companyCustomerCode,
    customerCode,
    customerGroup,
    customerGroupCode,
    supplierCode,
    supplierCodeApprv,
    referenceOJKSlice,
    prospectCode,

    SPPA,
    SimulasiAngsuran,
    LMSLoanPayment,
    LMSRestrukturisasi,
    BankAccount,
    GlAccount,
    collateral,
    Pdc,
    PaymentApproval,
    receptionSuspend,
    reversalSuspend,
    suspendSplit,
    bankAccount,
    glAccount,
    jurnalTemplate,
    glJournalQueryBuilder,
    glJournalScheme,
    glMasterSequence,
    loanVA,
    virtualAccount,
    supplierInvoice,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
